export default __webpack_public_path__ + "static/media/green-course-background.425c2b4e.svg";